/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-25 14:14:54
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-10-11 14:39:05
 * @FilePath: \mpc-2\features\mpc-common\src\components\ReasonModal\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import globalLoading from "#components/globalLoading";
import withFunctionCall from "#utils/withFunctionCall";
import { Form, Input, Modal } from "@bedrock/components"
import React from "react"

interface BackModalProps {
  onOk: (data: { reason?: string }) => void;
  onCancel?: () => void;
  headerPlace?: React.ReactNode;
  reasonLabel?: string;
  reasonRequired?: boolean;
  reasonCompProps?: React.ComponentProps<typeof Input.TextArea>;
}

const ReasonModal = (props: React.ComponentProps<typeof Modal> & BackModalProps) => {
  const { headerPlace, reasonLabel = '退回原因', reasonRequired = true,  reasonCompProps = { maxLength: 200 }, ...rest } = props;

  const [form] = Form.useForm();

  const handleOk = async () => {
    const data = await form.validateFields();
    globalLoading.show();
    try {
      await props.onOk(data);
      props.onCancel?.();
    } catch (error) {
      console.log(error);
    }
    globalLoading.done();
  }

  return (
    <Modal
      destroyOnClose
      maskClosable={false}
      title="退回"
      width={480}
      {...rest}
      onOk={handleOk}
    >
      {headerPlace}
      <Form form={form} showLabelColon layout='vertical'>
        <Form.Item rules={[{ required: reasonRequired, message: '请输入' }]} label={reasonLabel} name="reason">
          <Input.TextArea showCount {...reasonCompProps} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default withFunctionCall(ReasonModal);